import { useContext } from 'react';
import { AssignPositionTableContext, IAssignPositionTableContext } from './AssignPositionTableContext';

export const useClientDetailsTable = () => useContext<IAssignPositionTableContext>(AssignPositionTableContext);
